module.exports = __webpack_public_path__ + "f7a07494bff140cd9df49194ead20ceb.svg";